import { CONNECT_GENERAL_QUERY_PARAMS } from '@atlassian/jira-common-constants/src/connect-general-query-params.tsx';
import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

// Don't forget to update CONNECT_ROUTES_SET in @atlassian/jira-common-constants/src/spa-routes
export const connectGeneralRoute: InvariantJiraRoute = {
	name: 'connect-general',
	path: '/plugins/servlet/ac/:addonKey/:moduleKey',
	query: CONNECT_GENERAL_QUERY_PARAMS,
};
